import React, {Fragment} from 'react';

export default function ModalContent({title, body, footer, onCloseModal, children}) {
    return (
        <Fragment>
        { children 
            ? <Fragment>{children}</Fragment>
            : <Fragment>
                {title && <header className="modal-header">{title} </header>}
                <div className="modal-body">{body}</div>
                {footer && <footer className="modal-footer">{footer}</footer>}
              </Fragment>}
        </Fragment>
    )
}

